module.exports = __webpack_public_path__ + "media/images/top/feature/feature-3-298e804c3889ebcb80be4ff6504a4ae7.png";